<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-5xl">
      <div class="px-6 py-4 text-left modal-content flex flex-col">
        <div class="flex items-center justify-between pb-3">
          <p class="text-2xl font-bold">{{ filename }}</p>
          <div class="z-50 cursor-pointer modal-close" @click="showModal = false">
            <XIcon class="w-5 h-5 text-black"/>
          </div>
        </div>
        <div class="mb-4 flex-auto">
          <div class="mb-8 h-full">
            <iframe
                :src="blobFile"
                allowfullscreen
                height="100%"
                width="100%"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
      blobFile: null,
      filename: null,
    }
  },
  methods: {
    downloadBase64File(filename, blobFile) {
      const linkSource = blobFile;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = filename;
      downloadLink.click();
    },
  },
  beforeMount() {
    this.$emitter.on('open-blob-modal', ({blob, filename}) => {
      if (blob.type === 'application/pdf') {
        this.filename = filename
        this.blobFile = URL.createObjectURL(new Blob([blob], {type: blob.type}));
        this.showModal = true
      } else {
        this.downloadBase64File(filename, URL.createObjectURL(new Blob([blob], {type: blob.type})))
      }
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-blob-modal')
  }
}
</script>
<style scoped>
.modal-content {
  height: 90vh;
}
</style>